module.exports = __webpack_public_path__ + "static/media/NewAppleWalletFullPhone-nz.08d6adfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/NewAppleWalletFullPhone-nz.png
// module id = 6156
// module chunks = 1